import { UsersPageThemeSizeConfig } from './types';

const medium: UsersPageThemeSizeConfig = {
  usersPage: {},
};

export default medium;
